import { useApi, useToaster, type AdminCreateDraftLeadRequest } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

/**
 * Composable for creating a draft lead (admin)
 */
export function useCreateDraftLead() {
    const api = useApi();
    const toaster = useToaster();
    const queryClient = useQueryClient();

    const { mutate, mutateAsync, isPending, error, data, reset } = useMutation({
        mutationFn: (payload: AdminCreateDraftLeadRequest) => {
            return api.admin.draftLeads.createDraftLead({ body: payload });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin", "draft-leads"] });
            toaster.create({
                title: "Draft lead created successfully",
                type: "success",
            });
        },
        onError: (error) => {
            toaster.create({
                title: "Failed to create draft lead",
                description: error.message || "An error occurred",
                type: "error",
            });
            console.error("[useCreateDraftLead] Error:", error);
        },
    });

    return {
        mutate,
        mutateAsync,
        isPending,
        error,
        data,
        reset,
    };
}
